import React, { FC } from 'react';
import { Stack, Button, Typography } from '@mui/material';
import { styles } from './styles';
import useLocales from '~/hooks/useLocales';

type Props = {
  masqueradeBack: () => void;
  fullname: string;
};

const MasqueradeBack: FC<Props> = ({ fullname, masqueradeBack }) => {
  const { t } = useLocales();

  return (
    <Stack sx={styles.body} direction="row" justifyContent="center" alignItems="center" gap="24px">
      <Stack direction="row" gap="5px">
        <Typography fontSize="14px" fontWeight="600" color="grey.800">
          {t('header.masquerade.name')}
        </Typography>
        <Typography fontSize="14px" fontWeight="600" color="warning.darker">
          {fullname}
        </Typography>
      </Stack>
      <Button variant="outlined" sx={styles.button} onClick={masqueradeBack}>
        {t('header.masquerade.back')}
      </Button>
    </Stack>
  );
};

export default MasqueradeBack;
